import React, { Component } from 'react';
import { withRouter } from '../utils/with-router';
import { Link } from "react-router-dom";
import { Button, Container, Form, FormGroup, Input, Label } from 'reactstrap';
import AppNavbar from '../layout/AppNavbar';
import apiService from '../ApiConfig';

class DeviceEdit extends Component {

    routePath = "devices";

    emptyItem = {
        name: '',
        macAddress: ''
    };

    constructor(props) {
        super(props);
        this.state = {
            item: this.emptyItem
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    async componentDidMount() {
        if (this.props.match.params.id !== 'new') {
            const device = await (await fetch('/'+this.routePath+`/${this.props.match.params.id}`)).json();
            this.setState({item: device});
        }
    }

    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;
        let item = {...this.state.item};
        item[name] = value;
        this.setState({item});
    }

    async handleSubmit(event) {
        event.preventDefault();
        const {item} = this.state;

        await fetch(apiService.device() + ('/'+ item.id), {
            method: (item.id) ? 'PUT' : 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(item),
        });
        this.props.history.push('/'+this.routePath);
    }

    render() {
        const {item} = this.state;
        const title = <h2>{item.id ? 'Edit Device' : 'Add Device'}</h2>;

        return <div>
            <AppNavbar/>
            <Container>
                {title}
                <Form onSubmit={this.handleSubmit}>
                    <FormGroup>
                        <Label for="name">Name</Label>
                        <Input type="text" name="name" id="name" value={item.name || ''}
                               onChange={this.handleChange} autoComplete="name"/>
                    </FormGroup>
                    <FormGroup>
                        <Label for="email">MacAddress</Label>
                        <Input type="text" name="macAddress" id="macAddress" value={item.macAddress || ''}
                               onChange={this.handleChange} autoComplete="macAddress"/>
                    </FormGroup>
                    <FormGroup>
                        <Button color="primary" type="submit">Save</Button>{' '}
                        <Button color="secondary" tag={Link} to="/devices">Cancel</Button>
                    </FormGroup>
                </Form>
            </Container>
        </div>
    }
}

export default withRouter(DeviceEdit);